import { createSelector } from '@ngrx/store';
import { selectCheckoutLoading } from '@modules/checkout-store/selectors/basket/basket.selectors';
import { selectFareSelectorsLoading } from '@modules/ticket-fares-store/selectors/fare-selectors/fare-selectors.selectors';

import {
  selectFlexiFaresLoading,
  selectPaygFaresLoading,
  selectSearchFaresLoading,
} from '@modules/ticket-fares-store/selectors/fares/fares.selectors';
import { LoadingDetails } from '@nx-ng/types';
import {
  selectCustomerDetailsLoading,
  selectPreviousApplicantsLoading,
} from '@modules/customer-store/selectors/customer-details.selectors';
import { selectCheckoutInProgress } from '@modules/checkout-store/selectors/complete-checkout';
import { selectOrderLoading } from '@modules/order-store/selectors/order-store.selectors';

export const selectGlobalLoading = createSelector(
  selectCustomerDetailsLoading,
  selectPreviousApplicantsLoading,
  selectCheckoutLoading,
  selectFlexiFaresLoading,
  selectPaygFaresLoading,
  selectSearchFaresLoading,
  selectFareSelectorsLoading,
  selectCheckoutInProgress,
  selectOrderLoading,
  (
    customerDetailsLoading: LoadingDetails,
    previousApplicantsLoading: LoadingDetails,
    basketLoading: LoadingDetails,
    flexiFaresLoading: LoadingDetails,
    paygFaresLoading: LoadingDetails,
    searchFaresLoading: LoadingDetails,
    fareSelectorsLoading: LoadingDetails,
    checkoutInProgressLoading: LoadingDetails,
    orderLoading: LoadingDetails
  ): // orderLoading: LoadingDetails
  LoadingDetails => {
    if (orderLoading.isLoading) {
      return orderLoading;
    }

    if (checkoutInProgressLoading.isLoading) {
      return checkoutInProgressLoading;
    }

    if (customerDetailsLoading.isLoading || customerDetailsLoading.isUpdating) {
      return customerDetailsLoading;
    }

    if (previousApplicantsLoading.isLoading) {
      return previousApplicantsLoading;
    }

    if (basketLoading.isLoading) {
      return basketLoading;
    }

    if (fareSelectorsLoading.isLoading) {
      return fareSelectorsLoading;
    }

    if (searchFaresLoading.isLoading) {
      return searchFaresLoading;
    }

    if (flexiFaresLoading.isLoading) {
      return flexiFaresLoading;
    }

    if (paygFaresLoading.isLoading) {
      return paygFaresLoading;
    }

    return {
      isLoading: false,
      text: '',
    };
  }
);
